<template>
	<div class="am-landing">
		<am-toolbar
			class="am-landing__toolbar"
			:active.sync="menu"
			@brand="onBrandClick"
			@contact="onContactClick"
		/>

		<transition name="navigation">
			<div
				class="am-landing__navigation"
				v-if="menu"
			>
				<div class="am-landing__container">
					<am-list
						class="am-landing__menu"
						:items="navigation"
						@input="onMenuChange"
					/>
				</div>
			</div>
		</transition>

		<am-home
			class="am-landing__view"
			:current="section"
			:anchors="anchors"
			:hero="hero"
			:about="about"
			:album="album"
			:parqueDasAmericas="parqueDasAmericas"
			:environment="environment"
			:chill="chill"
			:safety="safety"
			:lifestyle="lifestyle"
			:sustainability="sustainability"
			:team="team"
			:promote="promote"
			:location="location"
			:timeline="timeline"
			:contact="contact"
			@gallery="onGalleryOpen"
			@submit="$store.commit('contact/submit', $event)"
			@click.native="menu = false; footer = false"
		/><!-- :blog="blog" -->

		<transition name="full-gallery">
			<am-full-gallery
				class="am-landing__full-gallery"
				v-if="gallery"
				:current="image"
				:images="images"
				@close="$store.commit('gallery/close')"
			/>
		</transition>

		<div class="am-landing__below" :class="{ 'is-active': footer }" v-if="viewport == 'desktop'">
			<am-down
				class="am-landing__down"
				:text="section == 'contact' ? 'Rodapé' : null"
				@click="onDownClick"
			/>

			<am-footer class="am-landing__footer" />
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import AMToolbar from '@/components/molecules/AMToolbar'
import AMDown from '@/components/molecules/AMDown'
import AMList from '@/components/molecules/AMList'
import AMFullGallery from '@/components/organisms/AMFullGallery'
import AMFooter from '@/components/organisms/AMFooter'
import AMHome from '@/components/templates/AMHome'

import axios from 'axios';

export default {
	components: {
		'am-toolbar': AMToolbar,
		'am-down': AMDown,
		'am-list': AMList,
		'am-full-gallery': AMFullGallery,
		'am-footer': AMFooter,
		'am-home': AMHome
	},

	computed: {
		...mapGetters({
			viewport: 'viewport/getCurrent',
			navigation: 'navigation/getItems',
/* 			navigationRoute: 'navigation/getItemsRoute',
 */			section: 'navigation/getCurrent',
			anchors: 'navigation/getAnchors',
			gallery: 'gallery/getActive',
			image: 'gallery/getCurrent',
			images: 'gallery/getImages'
		}),

		menu: {
			get() { return this.$store.state.navigation.active },
			set(value) { this.$store.commit('navigation/setActive', value) }
		},
	},

	data: () => ({
		footer: false,

		// Inicio
		hero: {
			titles: [
				'Descubra.',
				'Experimente.',
				'Desbrave.'
			],
			text: 'O Condomínio das Américas chegou a João Pessoa para renovar a sua experiência em morar.',
			background: require('@/assets/images/hero/background.jpg'),
			image: require('@/assets/images/hero/image.jpg')
		},

		// Sobre
		about: {
			title: 'Sobre o<br /> Empreendimento',
			text: 'O Condomínio das Américas chegou a João Pessoa com a proposta de ser um dos empreendimentos mais imponentes do Nordeste. De arquitetura moderna, reúne luxo, bem-estar e qualidade de vida e, em breve, se tornará referência de moradia na cidade, com estilo exclusivo, de alto padrão de qualidade.',
			images: [
				'/images/blueprint.jpg'
			]
		},

		// Galeria
		album: {
			images: [
				{
					caption: 'Localização',
					path: require('@/assets/images/album/Condominio_das_Americas_Localizacao.jpg'),
				},
				{
					caption: 'Vista aérea',
					path: require('@/assets/images/album/Condominio_das_Americas_Vista_Aerea.jpg')
				},
				{
					caption: 'Pórtico de Entrada',
					path: require('@/assets/images/album/Condominio_das_Americas_AereaEntrada.jpg'),
				},
				{
					caption: 'Pórtico em concreto branco',
					path: require('@/assets/images/album/Condominio_das_Americas_Guarita.jpg'),
				},
				{
					caption: 'Bloco administrativo e guarita de retaguarda',
					path: require('@/assets/images/album/Condominio_das_Americas_Administracao.jpg'),
				},
				{
					caption: 'Complexo Esportivo',
					path: require('@/assets/images/album/Condominio_das_Americas_AereaEsportes.jpg'),
				},
				{
					caption: 'Ginásio coberto',
					path: require('@/assets/images/album/Condominio_das_Americas_Quadra.jpg'),
				},
				{
					caption: 'Área de lazer',
					path: require('@/assets/images/album/Condominio_das_Americas_Area_de_Lazer.jpg'),
				},
				{
					caption: 'Terraço de apoio à piscina',
					path: require('@/assets/images/album/Condominio_das_Americas_LazerPiscina.jpg'),
				},
				{
					caption: 'Espaço Gourmet',
					path: require('@/assets/images/album/Condominio_das_Americas_EspacoGourmet.jpg'),
				},
				{
					caption: 'Spa com piscina aquecida',
					path: require('@/assets/images/album/Condominio_das_Americas_SPA.jpg'),
				},
				{
					caption: 'Academia',
					path: require('@/assets/images/album/Condominio_das_Americas_Academia.jpg'),
				},
				{
					caption: 'Espaço Kids',
					path: require('@/assets/images/album/Condominio_das_Americas_BlocoKidsJogos.jpg'),
				},
				{
					caption: 'Brinquedoteca',
					path: require('@/assets/images/album/Condominio_das_Americas_KidsClub.jpg'),
				},
				{
					caption: 'Salão de Festas',
					path: require('@/assets/images/album/Condominio_das_Americas_SalaoFestas334.jpg'),
				},
				{
					caption: 'Interior do salão de festas',
					path: require('@/assets/images/album/Condominio_das_Americas_SalaoFestas333.jpg'),
				},
				{
					caption: 'Área externa do salão de festas',
					path: require('@/assets/images/album/Condominio_das_Americas_SalaoFestas332.jpg'),
				},
				{
					caption: 'Alameda',
					path: require('@/assets/images/album/Condominio_das_Americas_Alameda.jpg'),
				},
				{
					caption: 'Castelo d`água e espaço pet',
					path: require('@/assets/images/album/Condominio_das_Americas_CasteloDagua.jpg'),
				}
			// 	{
			// 		caption: 'Vista Geral Sul',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_VistaGeralSul.jpg')
			// 	},
			// 	{
			// 		caption: 'Vista do Parque',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_VistaParque303.jpg'),
			// 	},
			// 	{
			// 		caption: 'Pórtico de Entrada',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_AereaEntrada.jpg'),
			// 	},
			// 	{
			// 		caption: 'Guarita',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_Guarita.jpg'),
			// 	},
			// 	{
			// 		caption: 'Bloco administrativo e guarita de retaguarda',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_Administracao.jpg'),
			// 	},
			// 	{
			// 		caption: 'Complexo Exportivo',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_AereaEsportes.jpg'),
			// 	},
			// 	{
			// 		caption: 'Area das Piscinas',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_AereaPiscina.jpg'),
			// 	},
			// 	{
			// 		caption: 'Quadra',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_Quadra.jpg'),
			// 	},
			// 	{
			// 		caption: 'Terraço de Apoio à Piscina',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_LazerPiscina.jpg'),
			// 	},
			// 	{
			// 		caption: 'Espaço Gourmet',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_EspacoGourmet.jpg'),
			// 	},
			// 	{
			// 		caption: 'Spa',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_SPA.jpg'),
			// 	},
			// 	{
			// 		caption: 'Academia',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_Academia.jpg'),
			// 	},
			// 	{
			// 		caption: 'Kids Jogos',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_BlocoKidsJogos.jpg'),
			// 	},
			// 	{
			// 		caption: 'Kids Club',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_KidsClub.jpg'),
			// 	},
			// 	{
			// 		caption: 'Salão de Festas',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_SalaoFestas332.jpg'),
			// 	},
			// 	{
			// 		caption: 'Salão de Festas',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_SalaoFestas333.jpg'),
			// 	},
			// 	{
			// 		caption: 'Salão de Festas',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_SalaoFestas334.jpg'),
			// 	},
			// 	{
			// 		caption: 'Alameda',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_Alameda.jpg'),
			// 	},
			// 	{
			// 		caption: 'Castelo D`água',
			// 		path: require('@/assets/images/album/Condominio_das_Americas_CasteloDagua.jpg'),
			// 	}
			]
		},

		// O parque
		parqueDasAmericas: {
			title: 'Parque das Américas <span>Um presente à cidade</span>',
			text: 'Gentileza Urbana. Foi a partir da corrente de empatia “gentileza gera gentileza” que o conceito se estendeu à arquitetura, projetando-se nas grandes cidades. O objetivo é agregar, às intervenções urbanas, elementos que gerem bem-estar. A gentileza urbana consiste em verdadeiras benfeitorias construídas em benefício da localidade. Localizado em frente ao condomínio, o Parque das Américas é um espaço de contato com a natureza que será entregue à cidade como um ato de gentileza urbana, disponibilizado para toda a sociedade. Inspirado no Parque Ibirapuera, sua área será propícia ao relaxamento, à caminhada e à prática de exercícios físicos em meio à exuberância do paisagismo, composto por espécies variadas de plantas, como ipês, palmeiras imperiais, arbustos, entre outras vegetações georreferenciadas. A área verde terá, ainda, ciclofaixa, pista para passeio, lago artificial, pista de skate e central de compostagem.',
			illustration: 'trees',
			images: [
				require('@/assets/images/album/Condominio_das_Americas_VistaParque302.jpg')
			]
		},

		// Ambiente e lazer
		environment: [
			{
				id: 1,
				name: 'Salão de Festas',
				image: require('@/assets/images/environment/01 - Condominio_das_Americas_SalaoFestas.jpg'),
				lat: -139.095703125,
				lng: 302.310546875
			},
			{
				id: 2,
				name: 'Salão Gourmet',
				image: require('@/assets/images/environment/02 - Condominio_das_Americas_EspacoGourmet.jpg'),
				lat: -185.29296875,
				lng: 279.90234375
			},
			{
				id: 3,
				name: 'Espaço Kids',
				image: require('@/assets/images/environment/03 - Condominio_das_Americas_KidsClub.jpg'),
				lat: -223.29296875,
				lng: 264.40234375
			},
			{
				id: 4,
				name: 'Piscinas',
				image: require('@/assets/images/environment/04 - Condominio_das_Americas_AereaPiscina.jpg'),
				lat: -193.79296875,
				lng: 307.90234375
			},
			{
				id: 5,
				name: 'Spa e Academia',
				image: require('@/assets/images/environment/05 - Condominio_das_Americas_Academia.jpg'),
				lat: -220.79296875,
				lng: 302.90234375
			},
			{
				id: 6,
				name: 'Guarita de Segurança',
				image: require('@/assets/images/environment/06 - Condominio_das_Americas_Guarita.jpg'),
				lat: -311.623046875,
				lng: 632.474609375
			},
			{
				id: 7,
				name: 'Campo de Futebol',
				image: require('@/assets/images/environment/07 - Condominio_das_Americas_CampoFutebol.jpg'),
				lat: -252.123046875,
				lng: 303.474609375
			},
			{
				id: 8,
				name: 'Ginásio Poliesportivo',
				image: require('@/assets/images/environment/08 - Condominio_das_Americas_Quadra.jpg'),
				lat: -282.123046875,
				lng: 309.474609375
			},
			{
				id: 9,
				name: 'Quadra de Tênis',
				// image: require('@/assets/images/environment/09 - 18_024_309_3DF_CAM_AereaEsportes.jpg'),
				image: require('@/assets/images/environment/09 - Condominio_das_Americas_QuadraTenis.jpg'),
				lat: -265.345703125,
				lng: 265.94140625
			},
			{
				id: 10,
				name: 'Minicampo',
				image: require('@/assets/images/environment/10 - Condominio_das_Americas_MiniCampo.jpg'),
				lat: -242.123046875,
				lng: 253.474609375
			},
			{
				id: 11,
				name: 'Castelo D`água',
				image: require('@/assets/images/environment/11 - Condominio_das_Americas_CasteloDagua.jpg'),
				lat: -59.369140625,
				lng: 325.357421875
			},
			{
				id: 12,
				name: 'Terraço de Apoio à Piscina',
				image: require('@/assets/images/environment/12 - Condominio_das_Americas_LazerPiscina.jpg'),
				lat: -207.630859375,
				lng: 290.99609375
			},
			{
				id: 13,
				name: 'Bloco Administrativo',
				image: require('@/assets/images/environment/13 - Condominio_das_Americas_Administracao.jpg'),
				lat: -338.587890625,
				lng: 617.25390625
			},
			{
				id: 14,
				name: 'Área do Parque das Américas',
				image: require('@/assets/images/environment/14 - Condominio_das_Americas_VistaParque.jpg'),
				lat: -195.826171875,
				lng: 791.8125
			},
		],

		// Tranquilidade
		chill: {
			title: 'Alto Padrão',
			text: 'O projeto do Condomínio das Américas foi pensado para oferecer a você ambientes e experiências de alto padrão de qualidade em moradia, o que se reflete em luxo, prazer e beleza. Paisagismo imponente; arquitetura moderna, ornamentada por painéis que fazem menção aos ladrilhos de Alfredo Volpi e de Athos Bulcão, considerados os artistas plásticos mais importantes da segunda geração do Modernismo.',
			illustration: 'birds',
			images: [
				require('@/assets/images/album/Condominio_das_Americas_Alameda.jpg')
			]
		},

		// Segurança
		safety: {
			title: 'Segurança',
			text: 'João Pessoa é conhecida por sua tranquilidade e reúne também critérios de cidade grande. No condomínio das Américas você vive esta plenitude associada a uma moradia segura. Aqui você conta com particularidades tais como: bollards, sala de monitoramento e guarita de retaguarda. Os bollards são a última palavra em segurança perimetral, sendo as melhores barreiras físicas de alta segurança, funcionalidade e designer. Fabricados em cilindro de aço retrateis com acionamento automatizado hidráulico, produzido sob os mais rígidos padrões internacionais.  Esses equipamentos serão instalados na guarita de entrada do condomínio, e mais adiante teremos a guarita de retaguarda que garante o acompanhamento de visitantes e prestadores de serviços. A sala de monitoramento garantirá vigilância permanente e em tempo real, trazendo ainda mais tranquilidade aos seus moradores. ',
			illustration: 'locker',
			images: [
				require('@/assets/images/safety/image.jpg')
			]
		},

		// Estilo de Vida
		lifestyle: {
			title: 'Estilo de Vida',
			text: 'O Condomínio está localizado em meio a uma extensa área verde de preservação permanente, na rota do ciclismo e entre cartões postais da cidade. A sua frente contamos com o parque que é um convite para exercícios ao ar livre por entre as árvores na companhia dos pássaros, ar puro, flores e frutos. A sensação de liberdade e beleza não está apenas do lado de fora, ela é percebida em toda área comum através das alamedas e dentro dos ambientes onde a arquitetura substitui as paredes por amplos painéis de vidro, integrando ao paisagismo. Atrelado ao ambiente que convida à saúde e ao bem estar encontram-se a área wellness. Que traz ainda mais conforto e suporte para quem gosta de viver bem e cuidar da saúde. Opções de sala de massagem, sauna, piscina aquecida, hidroterapia e uma academia com equipamentos de alta tecnologia em monitoramento e simuladores completa de diferentes treinos para diferentes necessidades. O condomínio das Américas é uma proposta única de estilo de vida.',
			illustration: 'star',
			images: [
				require('@/assets/images/album/Condominio_das_Americas_Academia.jpg')
			]
		},

		// Sustentabilidade
		sustainability: {
			title: 'Sustentabilidade',
			text: 'O compromisso com a sustentabilidade está presente nos projetos do condomínio e do Parque das Américas. Serão instalados painéis solares com células fotovoltaicas nos blocos das áreas comuns: ginásio poliesportivo; academia e spa; salão de festas; terraço gourmet e apoio à piscina; salão de jogos e espaço kids. A previsão inicial de geração de energia é de 30.416kWh por mês. Já a rede de distribuição d´água, oriunda de fontes distintas, foi pensada para o aproveitamento máximo dos recursos naturais e contará com poços artesianos. O Parque das Américas, por sua vez, construído como gentileza urbana, terá a instalação de central de compostagem.',
			illustration: 'leaf',
			images: [
				require('@/assets/images/album/Condominio_das_Americas_Area_de_Lazer.jpg')
			]
		},

		// Equipe
		team: [
			{
				name: 'Benedito Abbud',
				role: 'Projeto Paisagístico',
				text: 'Benedito Abbud, com seu escritório renomado com projetos assinados nacional e internacionalmente, é mestre em paisagismo e seu foco de trabalho é a criação de projetos e planos de arquitetura paisagística com identidade própria, promovendo lazer e convívio social através da vitalidade da paisagem.',
				photo: require('@/assets/images/team/benedito_abbud.jpg')
			},
			{
				name: 'Paulo Macedo',
				role: 'Arquiteto',
				text: 'Natural de João Pessoa, o renomado arquiteto e urbanista Paulo Macedo é formado pela Universidade Federal da Paraíba (UFPB) e possui quase 30 anos de uma carreira cheia de experiências de sucesso nos muitos projetos de empreendimentos realizados pelo seu escritório de arquitetura.',
				photo: require('@/assets/images/team/paulo_macedo.jpg')
			},
		],

		// Promova
		promote: {
			thumbnail: require('@/assets/images/promote/thumbnail.jpg'),
			video: 'qsbIJRoocVA',
			book: '/files/book-digital.pdf'
		},

		// Localização
		location: [
			{
				name: 'Empreendimento',
				address: `
					Condomínio das Américas<br />
					Av. Panorâmica<br /> 
					Altiplano Nobre<br />
					Vizinho à Estação das Artes<br />
					João Pessoa / PB
				`,
				marker: {
					lat: -7.152934,
					lng: -34.796031
				}
			},
			{
				name: 'Showroom',
				address: `
					Av. Nego, 870, Sala 101<br />
					Tambaú<br />
					João Pessoa / PB
				`,
				marker: {
					lat: -7.1133921,
					lng: -34.8304547
				}
			}
		],

		// Acompanhe a obra
		timeline: {
			title: 'Acompanhe o andamento da obra',
			text: 'Confira todos os detalhes do andamento da obra e fique por dentro de cada entrega do empreendimento',
			background: require('@/assets/images/hero/background.jpg'),
			image: require('@/assets/images/timeline/image.jpeg')
		},
		// Inicio
		blog: {
			titles: [
				'Desbrave.',
				'Ideias e',
				'Dicas.'
			],
			text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent finibus ligula non libero feugiat, sed ti',
			posts: [
				{
					id: 1, 
					title: "Entenda o que é a Arquitetura Moderna e quais são suas influências 1", 
					slug: "slug",
					category: "category",
					img: require('@/assets/images/hero/image.jpg'),
					text: "text",
					created_at: "created_at"
				},
				{
					id: 2, 
					title: "Entenda o que é a Arquitetura Moderna e quais são suas influências 1", 
					slug: "slug",
					category: "category",
					img: require('@/assets/images/hero/image.jpg'),
					text: "text",
					created_at: "created_at"
				}
			],
			background: require('@/assets/images/hero/background.jpg'),
			init: false
		},
		// Contato
		contact: {
			showroom: '83 99840-0076'
		}
	}),
	mounted () {
		//esconde o menu ao carregar a pagina
		
		this.hideMenu();
		axios
		.get(process.env.API + '/api/posts')
		.then(response => {
			this.blog.posts = response.data.data;
			this.blog.posts.forEach(p => {
				p.img = process.env.API + '/storage/posts/' + p.img;
			});
			this.blog.init = true;
			console.log("posts carregados com sucesso"); 
			console.log(this.blog.posts); 
			// console.log(this.timeline_inside2); 
		})
		/* console.log("fui chamado"); */
	},
	methods: {
		hideMenu(){
			this.menu = false
		},
		onBrandClick() {
			this.menu = false
			this.$store.commit('navigation/setCurrent', 'hero')
		},
		
		onMenuChange(value) {
			if (this.viewport == 'smartphone') {
				setTimeout(() => this.menu = false, 300)
				setTimeout(() => this.$store.commit('navigation/setCurrent', value), 500)
			} else {
				this.menu = false
				this.$store.commit('navigation/setCurrent', value)
			}
		},

		onDownClick() {
			if (this.section == 'contact')
				this.footer = !this.footer
			else
				this.$store.commit('navigation/next')
		},

		onGalleryOpen(payload) {
			this.$store.commit('gallery/open', payload)
		},

		onContactClick() {
			this.$store.commit('navigation/setCurrent', 'contact')
		}
	}
}
</script>

<style lang="scss">
body, html{
	height: 100%
}

.am-landing{
	display: flex;
	flex-flow: column;
	position: relative;

	&__toolbar{
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 40;
	}
	&__navigation{
		position: fixed;
		width: 100%;
		top: 60px;
		left: 0;
		bottom: 0;
		background: white;
		padding: 0 24px;
		box-sizing: border-box;
		z-index: 30;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.04);
	}
	&__container,
	&__menu{
		height: 100%;
	}
	&__full-gallery{
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 100;
	}
	&__below{
		position: absolute;
		left: 0;
		width: 100%;
		bottom: 0;
		transform: translateY(100%);
		transition: .3s $easeInOutQuad;
		display: none;
		&.is-active{
			transform: translateY(0%);
		}
	}
	&__down{
		position: absolute;
		bottom: 100%;
		left: 50%;
		transform: translateX(-50%);
		z-index: 50;
	}
	&__footer{
		width: 100%;
	}

	@include grid-media($smartphone-grid) {
		.am-landing{
			//
		}
	}

	@include grid-media($desktop-grid) {
		&__navigation{
			height: auto;
			bottom: inherit;
			padding: 24px;
		}
		&__container{
			@include outer-container;
		}
		&__menu{
			@include grid-column(12);
		}
		&__below{
			display: flex;
		}
		.am-landing{
			//
		}
	}
}
</style>
